import i18next from "@config/i18next";

import { GenericErrorToastFactory } from "@containers/Toastify";

export const showGenericErrorToast = (customMessage?: string | null) => {
  const toast = GenericErrorToastFactory(
    i18next.t(customMessage || "batmaid_pwa_generic.something_went_wrong"),
    "batmaid-generic-error",
  );

  toast(customMessage);
};
